import { useEffect, useState } from 'react';
import { checkOrgValidation, OrgValidationType } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { useParams } from 'react-router';
import { get } from 'lodash';
import {
  DbGuardAllowedResources,
  getOrganizationGuardDbResource,
  getOrganizationGuardFhirResource,
} from './organizationBasedGuard.utils';
import PermissionDenied from 'src/pages/dashboard/PermissionDenied';

type ResourcePath = {
  resourceName: string;
  resourcePath: string;
  resourceType: OrgValidationType;
};

type OrganizationBasedGuardProps = {
  children: React.ReactNode;
  identifierNameInPath: string;
  resourcePaths: ResourcePath[];
};

export function OrganizationBasedGuard({
  children,
  identifierNameInPath,
  resourcePaths,
}: OrganizationBasedGuardProps) {
  const urlParams = useParams();

  const [resource, setResource] = useState<any>(null);
  const [resourceIdentifierValue, setResourceIdentifierValue] = useState<string | null>(null);
  const [organizationToValidate, setOrganizationToValidate] = useState<string | null>(null);

  useEffect(() => {
    const identifierInPath = urlParams?.[identifierNameInPath];
    if (identifierInPath) {
      setResourceIdentifierValue(identifierInPath);
    } else {
      setResourceIdentifierValue(null);
    }
  }, [identifierNameInPath, urlParams]);

  const handleGetFhirResource = async (
    resourcePaths: ResourcePath[],
    resourceIdentifierValue: string
  ) => {
    let currentIdentifierValue = resourceIdentifierValue;
    let response: any = null;
    try {
      for (let i = 0; i < resourcePaths.length; i++) {
        const resourcePath = resourcePaths[i];
        if (resourcePath.resourceType === OrgValidationType.DB) {
          response = await getOrganizationGuardDbResource(
            DbGuardAllowedResources[resourcePath.resourceName],
            currentIdentifierValue
          );
          currentIdentifierValue = get(response, resourcePath.resourcePath);
        } else if (resourcePath.resourceType === OrgValidationType.FHIR) {
          response = await getOrganizationGuardFhirResource(
            resourcePath.resourceName,
            currentIdentifierValue
          );
          currentIdentifierValue = get(response, resourcePath.resourcePath)?.split('/')?.[1];
        }
      }

      if (response && currentIdentifierValue) {
        setResource(response);
        setOrganizationToValidate(currentIdentifierValue);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!resourceIdentifierValue || !resourcePaths || resourcePaths.length === 0) {
      return;
    }

    handleGetFhirResource(resourcePaths, resourceIdentifierValue);
  }, [resourcePaths, resourceIdentifierValue]);

  if (resource && organizationToValidate) {
    if (checkOrgValidation({ organizationToValidate })) {
      return <>{children}</>;
    } else {
      return <PermissionDenied />;
    }
  }

  return null;
}
